export default __webpack_public_path__ + "static/media/RhymesCountAlong_08.7309a471.png";